module.exports = __webpack_public_path__ + "img/9600.78d882aa.jpg";